"use client";

import { Card, CardBody } from "@nextui-org/card";
import test from "node:test";
import { ReactElement, useState } from "react";

export interface NosProduitsCardProps {
  form: true | false,
  test: string,
  example: string,
  fromTitle: string,
  tabLabel: string;
  content: {
    title: string,
    pointList: true | false,
    content: {
      bold: string | null,
      content: string,
    }[],
  }[],
  conclusion: string | null;
  note: string | null,
  image: ReactElement,
  contact: string,
}



export default function NosProduitsCard({
  form,
  test,
  example,
  content,
  image,
  note,
  conclusion,
  fromTitle,
  contact,
}: NosProduitsCardProps) {
  
  const [domain, setDomain] = useState('');

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setDomain(event.target.value);
    };

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const pattern = /^(([a-zA-Z0-9-]{1,63}\.)+[a-zA-Z]{2,63})$/;
        if (pattern.test(domain)) {
          window.open(`https://adaptify-demo.greendev-access.fr/${domain}`, '_blank');
        } else {
          alert("Le nom de domaine n'est pas valide")
        }

      };

  return (
    <Card className="bg-background-50">
      <CardBody className="p-8">
        {form && 
          <form onSubmit={handleSubmit} className="text-center mb-14">
              <label className="text-3xl font-bold" htmlFor="champ-url">{fromTitle}
                <div className="flex-row text-center mt-6 text-lg">
                  <input
                  placeholder={example}
                  className="mr-3 w-1/3 p-1 bg-foreground-900 text-background rounded border-foreground border-2"
                  type="text"
                  id="champ-url"
                  name="domain"
                  value={domain}
                  onChange={handleInputChange}
                  required
                  />
                  <button className="bg-foreground border-foreground-900 border-2 text-background p-1 px-5 rounded font-bold" type="submit">{test}</button>
                </div>
              </label>
          </form>
        }

        <div className="grid grid-cols-2 lg:grid-cols-12 gap-6 lg:gap-10 items-center justify-center text-foreground-900">
          <div className="relative col-span-6 lg:col-span-4 w-full flex justify-center">
            {image}
          </div>

          <div className="flex flex-col justify-start md:mx-28 lg:mx-5 h-full col-span-6 lg:col-span-8 gap-6">

            {content.map((chip) =>(
              <>
                <h2 className="text-2xl font-bold text-foreground">{chip.title}</h2>

                  {chip.content.map((item, index)=>(
                    <div className={`-my-2`} key={`chip-${index}`}>{item.bold && <h3 className="font-bold text-lg -mb-2">{item.bold}</h3>}<p className="my-2">{item.content}</p></div>
                ))}
              </>
            ))}
            {conclusion !== null && <p>{conclusion}</p>}
            {note !== null && <p className="font-bold text-lg">{note}</p> }
            {form &&
            <a href="https://adaptify.fr" target="_blank" className="text-2xl w-full text-center underline text-foreground">
              {contact}
            </a>
            }
          </div>
        </div>
      </CardBody>
    </Card>
  );
}
